import React, { useState, useContext } from 'react';
import { Button, CircularProgress, Box, TextField, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera'; // Nuevo ícono
import { useSnackbar } from 'notistack';
import ImageIcon from '@mui/icons-material/Image';
import TokenContext from './TokenContext';
import s3Api from '../api/S3Api';

function Images({ countryCode }) {
    const { token } = useContext(TokenContext);
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
    const { enqueueSnackbar } = useSnackbar();


    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    };

    const handleUpload = async () => {
        if (!file) return;

        setIsLoading(true);
        try {
            const imageUrl = await s3Api.uploadImage(countryCode, file, token);
            enqueueSnackbar('Image uploaded successfully', { variant: 'success' });
            setUploadedImageUrl(imageUrl);
        } catch (error) {
            enqueueSnackbar('Error uploading image', { variant: 'error' });
        }
        setIsLoading(false);
    };

    const handleCopyUrl = () => {
        navigator.clipboard.writeText(uploadedImageUrl);
    };

    const handleUploadAnother = () => {
        setFile(null);
        setUploadedImageUrl(null);
    };

    return (
        <Box 
            style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                border: '2px dashed lightgray', 
                backgroundColor: '#f5f5f5',  // Fondo gris
                padding: '20px', 
                width: '400px',
                height: '450px' 
            }}
        >
            {uploadedImageUrl ? (
                <>
                    <img src={uploadedImageUrl} alt="Subida" style={{ maxWidth: '100%', maxHeight: '200px', marginBottom: '20px' }} />
                    <TextField
                        value={uploadedImageUrl}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        InputProps={{
                            endAdornment: (
                                <IconButton onClick={handleCopyUrl}>
                                    <FileCopyIcon />
                                </IconButton>
                            ),
                        }}
                    />
                    <Button style={{ marginTop: '20px' }} variant="outlined" onClick={handleUploadAnother}>Upload another image</Button>
                </>
            ) : (
                <>
                    {isLoading ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <input
                                accept="image/*"
                                id="upload-image"
                                type="file"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                            <label htmlFor="upload-image" style={{ cursor: 'pointer' }}>
                                <Box style={{ padding: '10px', textAlign: 'center', cursor: 'pointer', minHeight: '100px', position: 'relative' }}>
                                    <ImageIcon style={{ fontSize: '60px', color: 'gray' }} />
                                    <div style={{ marginTop: '10px' }}>
                                    Click to upload an image
                                    </div>
                                </Box>
                            </label>
                            <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px', textAlign: 'center' }}>
                                Please ensure your image is in .png format. The filename should not contain accents, spaces, or special characters.
                            </Typography>
                            {file && <Button variant="contained" color="primary" onClick={handleUpload} style={{ marginTop: '10px' }}>Subir</Button>}
                        </>
                    )}
                </>
            )}
        </Box>
    );
    
    
}

export default Images;
